angular.module('zc.core')

.directive 'dateTimePicker', ($filter) ->
  restrict: 'EA'
  scope:
    data: '=?ngModel'
    date: '=?'
    isRequired: '=?'
    region: '<'
    productLine: '<'
    interval: '<'
  template: '''
    <div class="row clearfix">
      <div class="col-md-6">
        <div class="date input-group input-group-lg">
          <span class="input-group-addon">
            <i class="fa fa-calendar"></i>
          </span>
          <input
            class="form-control form_datepick"
            ng-class="{
              'ng-invalid': isRequired && !data.date
            }"
            ng-style="{
              'border': borderStyle
            }"
            datepick
            size="16"
            type="text"
            date="data.date"
            ng-required="isRequired"/>
        </div>
      </div>
      <div class="col-md-6">
        <div class="time input-group input-group-lg">
          <span class="input-group-addon">
            <i class="glyphicon glyphicon-time"></i>
          </span>
          <input
            class="form-control form_timepick"
            ng-class="{
              'ng-invalid': isRequired && !data.time && data.time !== 0
            }"
            ng-style="{
              'border': borderStyle
            }"
            timepick
            size="16"
            type="text"
            time="data.time"
            interval="interval"
            ng-required="isRequired"/>
            <span
              class="input-group-addon"
              tooltip="{{ region | gmtNotation }}">
              {{ gmtOffset }}
            </span>
        </div>
      </div>
    </div>
    '''
  link: (scope, element, attrs) ->
    region = if scope.region then scope.region else 'Asia/Tokyo'

    scope.gmtOffset = "(#{moment().tz(region).format('Z')})"
    scope.isNotLite = scope.productLine && scope.productLine != 'zenclerk_s'
    scope.borderStyle = if scope.isNotLite then 'solid 1px #ccc' else 'auto'

    scope.$watch 'date', (newValue) ->
      return unless newValue
      scope.data = $filter('dateToDateObj')(newValue)
    , true
    scope.$watch 'data', (newValue) ->
      return unless newValue
      scope.date = $filter('dateObjToDate')(newValue)
    , true

.directive 'timepick', ['$timeout', ($timeout) ->
  return {
    restrict: 'A'
    require: '?time'
    scope:
      time: '='
      interval: '='
    link: (scope, element, attrs) ->
      processChange = (ev) ->
        if typeof ev.select == 'undefined'
          # clear the date
          scope.$apply (scope) ->
            scope.time = undefined
        else
          scope.$apply (scope) ->
            scope.time = ev.select

      $input = element.pickatime
        onSet: processChange
        format: 'HH:i'
        formatSubmit: 'HH:i'
        interval: scope.interval

      picker = $input.pickatime 'picker'

      if scope.time or scope.time == 0
        $timeout ->
          picker.set('select', scope.time)

      scope.$watch 'time', (newValue) ->
        if typeof newValue != 'undefined'
          $timeout ->
            picker.set 'select', newValue

      # disable activating when window becomes focused
      $input.off 'focus'

  }
]

.directive 'datepick', ['$timeout', '$filter', ($timeout, $filter) ->
  return {
    restrict: 'A'
    require: '?date'
    scope:
      date: '='
      min: '='
      max: '='
    link: (scope, element, attrs) ->
      updateDate = (newValue, oldValue) ->
        return if newValue is oldValue
        if newValue
          picker.set 'select', moment(newValue).format()
        else
          picker.clear()

      updateMin = (newValue) ->
        min = if newValue then moment(newValue).startOf('day').toDate() else false
        picker.set 'min', min

      updateMax = (newValue) ->
        max = if newValue then moment(newValue).endOf('day').toDate() else false
        picker.set 'max', max

      processChange = (ev) ->
        return if scope.$$phase or scope.$root.$$phase
        if typeof ev.select == 'undefined'
          # clear the date
          scope.$apply (scope) ->
            scope.date = null
        else
          scope.$apply (scope) ->
            scope.date = moment(ev.select).startOf('day').format()

      $input = element.pickadate
        onSet: processChange
        format: $filter('translate')('sharedModules.dateTimeFormats.dateTimePicker.format')
        formatSubmit: $filter('translate')('sharedModules.dateTimeFormats.dateTimePicker.format')

      picker = $input.pickadate 'picker'

      # disable activating when window becomes focused
      $input.off 'focus'

      updateDate scope.date
      updateMin scope.min
      updateMax scope.max
      scope.$watch 'date', updateDate, true
      scope.$watch 'min', updateMin, true
      scope.$watch 'max', updateMax, true

  }
]



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/date_time_picker.js.coffee